import { render, staticRenderFns } from "./ReservationInformation.vue?vue&type=template&id=cffb8c02&"
import script from "./ReservationInformation.vue?vue&type=script&lang=js&"
export * from "./ReservationInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BCard} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BCard})
    

export default component.exports